<template>
  <button
      :class="[
        colorType === 'main' ? styles.btn_main_icon : styles.btn_secondary_icon,
        { 'md:hover:scale-110 transition duration-300 ease-out': transform && anim }
        ]"
      :disabled="load"
  >
    <my-loader v-if="load"></my-loader>
    <BaseIcon
        v-else
        :icon="icon"
        :size="sizeIcon"
    />
  </button>
</template>

<script>
import MyLoader from '../../MyLoader'
import BaseIcon from '../BaseIcon'

export default {
  name: 'BaseButtonIcon',
  components: {
    BaseIcon,
    MyLoader
  },
  props: {
    icon: {
      type: String,
      required: true
    },

    sizeIcon: String,
    transform: {
      type: Boolean,
      default: false
    },

    colorType: {
      type: String,
      default: 'main',
      validator (value) {
        return ['main', 'secondary'].includes(value)
      }
    },

    load: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      styles: window.myStyles,
      anim: window.anim
    }
  }
}
</script>

<style scoped>

</style>
